import * as React from "react";
import TabPanelCmp from "../../../../components/tabPanel/tabPanelCmp";
import DynamicActionForm from "./dynamicActionForm";

interface tabsInterface {
  tabs: any;
  setTabs: any;
  // tabPanel:any
  color?: string;
  inputsError?: boolean;
}

export default function DynamicActionTab({
  tabs,
  setTabs,
  color = "#E57373",
  inputsError,
}: tabsInterface) {
  let createdTabs = [] as any;
  let itemIndex = 0;
  const updateTab = (index: number, inputs: any) => {
    tabs[index].inputs = inputs;
    setTabs(tabs);
  };
  tabs?.map((item: any, index: number) => {
    item.id = itemIndex;
    let formData = item.inputs;
    item.child = (
      <DynamicActionForm
        inputsError={inputsError}
        inputs={formData}
        tabIndex={index}
        updateTab={updateTab}
      />
    );
    itemIndex++;
    createdTabs.push(item);
  });
  return (
    <TabPanelCmp
      tab={createdTabs}
      //  colorTab={"#E6123D"}
      colorTab={color}
      childHeight={"null"}
    />
  );
}
